export const JSON_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};
export const HttpSuccessCode = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_RESPONSE: 204,
};
export const HttpClientErrorCode = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    CONTENT_TOO_LARGE: 413,
};
export const HttpServerErrorCodes = {
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
};
export const HttpErrorCode = {
    ...HttpClientErrorCode,
    ...HttpServerErrorCodes,
};
export const HttpStatusCode = {
    ...HttpSuccessCode,
    MULTIPLE_CHOICES: 300,
    ...HttpErrorCode,
};
export const isSuccessStatusCode = (status) => status >= HttpStatusCode.OK && status < HttpStatusCode.MULTIPLE_CHOICES;
export const isError = (status) => status >= HttpStatusCode.BAD_REQUEST;
export const isAccessDenied = (status) => status === HttpStatusCode.UNAUTHORIZED ||
    status === HttpStatusCode.FORBIDDEN;
